/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SAFc Backend
 * The 24/7 API description
 * OpenAPI spec version: 1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import healthControllerPingMutator from '../response-type.js';
import healthControllerGetVersionMutator from '../response-type.js';
import healthControllerGetHealthApiMutator from '../response-type.js';
import healthControllerGetHealthDbMutator from '../response-type.js';
import healthControllerGetHealthSumsubMutator from '../response-type.js';


type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const healthControllerPing = (

 options?: SecondParameter<typeof healthControllerPingMutator>,signal?: AbortSignal
) => {


      return healthControllerPingMutator<string>(
      {url: `/api/ping`, method: 'GET', signal
    },
      options);
    }




export const getHealthControllerPingQueryKey = () => {
    return [
    `/api/ping`
    ] as const;
    }


export const getHealthControllerPingQueryOptions = <TData = Awaited<ReturnType<typeof healthControllerPing>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthControllerPing>>, TError, TData>>, request?: SecondParameter<typeof healthControllerPingMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHealthControllerPingQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof healthControllerPing>>> = ({ signal }) => healthControllerPing(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof healthControllerPing>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HealthControllerPingQueryResult = NonNullable<Awaited<ReturnType<typeof healthControllerPing>>>
export type HealthControllerPingQueryError = unknown


export function useHealthControllerPing<TData = Awaited<ReturnType<typeof healthControllerPing>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthControllerPing>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof healthControllerPing>>,
          TError,
          Awaited<ReturnType<typeof healthControllerPing>>
        > , 'initialData'
      >, request?: SecondParameter<typeof healthControllerPingMutator>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHealthControllerPing<TData = Awaited<ReturnType<typeof healthControllerPing>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthControllerPing>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof healthControllerPing>>,
          TError,
          Awaited<ReturnType<typeof healthControllerPing>>
        > , 'initialData'
      >, request?: SecondParameter<typeof healthControllerPingMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHealthControllerPing<TData = Awaited<ReturnType<typeof healthControllerPing>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthControllerPing>>, TError, TData>>, request?: SecondParameter<typeof healthControllerPingMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useHealthControllerPing<TData = Awaited<ReturnType<typeof healthControllerPing>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthControllerPing>>, TError, TData>>, request?: SecondParameter<typeof healthControllerPingMutator>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHealthControllerPingQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const healthControllerGetVersion = (

 options?: SecondParameter<typeof healthControllerGetVersionMutator>,signal?: AbortSignal
) => {


      return healthControllerGetVersionMutator<string>(
      {url: `/api/version`, method: 'GET', signal
    },
      options);
    }




export const getHealthControllerGetVersionQueryKey = () => {
    return [
    `/api/version`
    ] as const;
    }


export const getHealthControllerGetVersionQueryOptions = <TData = Awaited<ReturnType<typeof healthControllerGetVersion>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthControllerGetVersion>>, TError, TData>>, request?: SecondParameter<typeof healthControllerGetVersionMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHealthControllerGetVersionQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof healthControllerGetVersion>>> = ({ signal }) => healthControllerGetVersion(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof healthControllerGetVersion>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HealthControllerGetVersionQueryResult = NonNullable<Awaited<ReturnType<typeof healthControllerGetVersion>>>
export type HealthControllerGetVersionQueryError = unknown


export function useHealthControllerGetVersion<TData = Awaited<ReturnType<typeof healthControllerGetVersion>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthControllerGetVersion>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof healthControllerGetVersion>>,
          TError,
          Awaited<ReturnType<typeof healthControllerGetVersion>>
        > , 'initialData'
      >, request?: SecondParameter<typeof healthControllerGetVersionMutator>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHealthControllerGetVersion<TData = Awaited<ReturnType<typeof healthControllerGetVersion>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthControllerGetVersion>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof healthControllerGetVersion>>,
          TError,
          Awaited<ReturnType<typeof healthControllerGetVersion>>
        > , 'initialData'
      >, request?: SecondParameter<typeof healthControllerGetVersionMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHealthControllerGetVersion<TData = Awaited<ReturnType<typeof healthControllerGetVersion>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthControllerGetVersion>>, TError, TData>>, request?: SecondParameter<typeof healthControllerGetVersionMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useHealthControllerGetVersion<TData = Awaited<ReturnType<typeof healthControllerGetVersion>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthControllerGetVersion>>, TError, TData>>, request?: SecondParameter<typeof healthControllerGetVersionMutator>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHealthControllerGetVersionQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const healthControllerGetHealthApi = (

 options?: SecondParameter<typeof healthControllerGetHealthApiMutator>,signal?: AbortSignal
) => {


      return healthControllerGetHealthApiMutator<boolean>(
      {url: `/api/health/api`, method: 'GET', signal
    },
      options);
    }




export const getHealthControllerGetHealthApiQueryKey = () => {
    return [
    `/api/health/api`
    ] as const;
    }


export const getHealthControllerGetHealthApiQueryOptions = <TData = Awaited<ReturnType<typeof healthControllerGetHealthApi>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthControllerGetHealthApi>>, TError, TData>>, request?: SecondParameter<typeof healthControllerGetHealthApiMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHealthControllerGetHealthApiQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof healthControllerGetHealthApi>>> = ({ signal }) => healthControllerGetHealthApi(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof healthControllerGetHealthApi>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HealthControllerGetHealthApiQueryResult = NonNullable<Awaited<ReturnType<typeof healthControllerGetHealthApi>>>
export type HealthControllerGetHealthApiQueryError = unknown


export function useHealthControllerGetHealthApi<TData = Awaited<ReturnType<typeof healthControllerGetHealthApi>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthControllerGetHealthApi>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof healthControllerGetHealthApi>>,
          TError,
          Awaited<ReturnType<typeof healthControllerGetHealthApi>>
        > , 'initialData'
      >, request?: SecondParameter<typeof healthControllerGetHealthApiMutator>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHealthControllerGetHealthApi<TData = Awaited<ReturnType<typeof healthControllerGetHealthApi>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthControllerGetHealthApi>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof healthControllerGetHealthApi>>,
          TError,
          Awaited<ReturnType<typeof healthControllerGetHealthApi>>
        > , 'initialData'
      >, request?: SecondParameter<typeof healthControllerGetHealthApiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHealthControllerGetHealthApi<TData = Awaited<ReturnType<typeof healthControllerGetHealthApi>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthControllerGetHealthApi>>, TError, TData>>, request?: SecondParameter<typeof healthControllerGetHealthApiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useHealthControllerGetHealthApi<TData = Awaited<ReturnType<typeof healthControllerGetHealthApi>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthControllerGetHealthApi>>, TError, TData>>, request?: SecondParameter<typeof healthControllerGetHealthApiMutator>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHealthControllerGetHealthApiQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const healthControllerGetHealthDb = (

 options?: SecondParameter<typeof healthControllerGetHealthDbMutator>,signal?: AbortSignal
) => {


      return healthControllerGetHealthDbMutator<boolean>(
      {url: `/api/health/db`, method: 'GET', signal
    },
      options);
    }




export const getHealthControllerGetHealthDbQueryKey = () => {
    return [
    `/api/health/db`
    ] as const;
    }


export const getHealthControllerGetHealthDbQueryOptions = <TData = Awaited<ReturnType<typeof healthControllerGetHealthDb>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthControllerGetHealthDb>>, TError, TData>>, request?: SecondParameter<typeof healthControllerGetHealthDbMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHealthControllerGetHealthDbQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof healthControllerGetHealthDb>>> = ({ signal }) => healthControllerGetHealthDb(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof healthControllerGetHealthDb>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HealthControllerGetHealthDbQueryResult = NonNullable<Awaited<ReturnType<typeof healthControllerGetHealthDb>>>
export type HealthControllerGetHealthDbQueryError = unknown


export function useHealthControllerGetHealthDb<TData = Awaited<ReturnType<typeof healthControllerGetHealthDb>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthControllerGetHealthDb>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof healthControllerGetHealthDb>>,
          TError,
          Awaited<ReturnType<typeof healthControllerGetHealthDb>>
        > , 'initialData'
      >, request?: SecondParameter<typeof healthControllerGetHealthDbMutator>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHealthControllerGetHealthDb<TData = Awaited<ReturnType<typeof healthControllerGetHealthDb>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthControllerGetHealthDb>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof healthControllerGetHealthDb>>,
          TError,
          Awaited<ReturnType<typeof healthControllerGetHealthDb>>
        > , 'initialData'
      >, request?: SecondParameter<typeof healthControllerGetHealthDbMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHealthControllerGetHealthDb<TData = Awaited<ReturnType<typeof healthControllerGetHealthDb>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthControllerGetHealthDb>>, TError, TData>>, request?: SecondParameter<typeof healthControllerGetHealthDbMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useHealthControllerGetHealthDb<TData = Awaited<ReturnType<typeof healthControllerGetHealthDb>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthControllerGetHealthDb>>, TError, TData>>, request?: SecondParameter<typeof healthControllerGetHealthDbMutator>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHealthControllerGetHealthDbQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const healthControllerGetHealthSumsub = (

 options?: SecondParameter<typeof healthControllerGetHealthSumsubMutator>,signal?: AbortSignal
) => {


      return healthControllerGetHealthSumsubMutator<boolean>(
      {url: `/api/health/sumsub`, method: 'GET', signal
    },
      options);
    }




export const getHealthControllerGetHealthSumsubQueryKey = () => {
    return [
    `/api/health/sumsub`
    ] as const;
    }


export const getHealthControllerGetHealthSumsubQueryOptions = <TData = Awaited<ReturnType<typeof healthControllerGetHealthSumsub>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthControllerGetHealthSumsub>>, TError, TData>>, request?: SecondParameter<typeof healthControllerGetHealthSumsubMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHealthControllerGetHealthSumsubQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof healthControllerGetHealthSumsub>>> = ({ signal }) => healthControllerGetHealthSumsub(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof healthControllerGetHealthSumsub>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HealthControllerGetHealthSumsubQueryResult = NonNullable<Awaited<ReturnType<typeof healthControllerGetHealthSumsub>>>
export type HealthControllerGetHealthSumsubQueryError = unknown


export function useHealthControllerGetHealthSumsub<TData = Awaited<ReturnType<typeof healthControllerGetHealthSumsub>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthControllerGetHealthSumsub>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof healthControllerGetHealthSumsub>>,
          TError,
          Awaited<ReturnType<typeof healthControllerGetHealthSumsub>>
        > , 'initialData'
      >, request?: SecondParameter<typeof healthControllerGetHealthSumsubMutator>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHealthControllerGetHealthSumsub<TData = Awaited<ReturnType<typeof healthControllerGetHealthSumsub>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthControllerGetHealthSumsub>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof healthControllerGetHealthSumsub>>,
          TError,
          Awaited<ReturnType<typeof healthControllerGetHealthSumsub>>
        > , 'initialData'
      >, request?: SecondParameter<typeof healthControllerGetHealthSumsubMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHealthControllerGetHealthSumsub<TData = Awaited<ReturnType<typeof healthControllerGetHealthSumsub>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthControllerGetHealthSumsub>>, TError, TData>>, request?: SecondParameter<typeof healthControllerGetHealthSumsubMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useHealthControllerGetHealthSumsub<TData = Awaited<ReturnType<typeof healthControllerGetHealthSumsub>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthControllerGetHealthSumsub>>, TError, TData>>, request?: SecondParameter<typeof healthControllerGetHealthSumsubMutator>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHealthControllerGetHealthSumsubQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






